import getLocaleConfig from '@/utils/getLocaleConfig';
import formatValue from '@/utils/formatValue';
import formatDate from '@/utils/formatDate';
import getDiffClass from '@/utils/getDiffClass';
import getFunnelChartSpec from '@/utils/getFunnelChartSpec';
import getSizeIndicatorChartSpec from '@/utils/getSizeIndicatorChartSpec';

import useSectionState from '@/state/useSectionState';

import {
  percentFormat,
} from '@/config/valueFormatConfig';
import i18n from '@/config/i18n';

const { t } = i18n.global;

const {
  sectionName,
  compsets,
  compsetNames,
  currentPermissions,
} = useSectionState();

const prepareDayModalData = ({
  data,
  minSize,
  maxSize,
  currentSizeMeasureConfig,
  barChartFormat,
}) => {
  const invertDiff = sectionName.value === 'disparities';
  const diff = formatValue(data.diff, percentFormat);
  const diffClass = getDiffClass(data.diff);
  const chartCurrency = data.barChartData[0]?.currency || getLocaleConfig().currency;

  const sizeValue = data.totalCalendarAvg;

  let legendValues;

  if (currentPermissions.value.calendar) {
    legendValues = compsetNames.value;
  } else {
    legendValues = compsets.value.map((item) => (item.isOwn ? 'Hotel' : item.compset));
  }

  const barChartSpec = getFunnelChartSpec({
    data: data.barChartData,
    dataFormat: barChartFormat,
    size: 'sm',
    legendValues,
  });

  const sizeIndicatorChartSpec = getSizeIndicatorChartSpec({
    data: { values: [{ value: data.totalCalendarAvg }] },
    min: minSize,
    max: maxSize,
    dataFormat: currentSizeMeasureConfig.format,
  });

  const isPositiveDiff = diffClass === 'positive';

  let diffSign = '-';
  let diffText = 'below';

  if ((invertDiff && !isPositiveDiff)
    || (!invertDiff && isPositiveDiff)) {
    diffSign = '+';
    diffText = 'above';
  }

  const texts = {
    date: formatDate(data.date, 'date'),
    diffTextValue: `${diffSign}${diff}`,
    comparedTo: t(`${diffText} compset`),
    barChartTitle: t(currentSizeMeasureConfig.metricName),
    sizeMetric: currentSizeMeasureConfig.measureText,
    tpConfig: {
      type: 'info',
      content: {
        text: `${t('Aggregated data of you and the compset.')} 
        ${t('Showing the aggregated position between the min and max for the selected dates')}`,
      },
      preferred: ['right'],
    },
  };

  return {
    dayData: {
      dateTs: data.date,
      sizeValue,
      diff,
      diffClass,
      texts,
      minSize,
      maxSize,
    },
    barChartConfig: {
      currency: chartCurrency,
      spec: barChartSpec,
    },
    sizeIndicatorChartConfig: {
      currency: chartCurrency,
      spec: sizeIndicatorChartSpec,
    },
  };
};

export default prepareDayModalData;
